import React, { useEffect, useState } from 'react';
import { Table, Button, Form, Modal, Container, Row, Col, Pagination } from "react-bootstrap";
import { dotoniwoofApi } from '../api/dotoniwooApi';
import Titulo from '../elements/Titulo';
import IconSearch from '../elements/IconSearch';
import { format } from 'date-fns';
import NavContainer from './Nav';
import OffCanvasNav from './OffCanvasNav';
import { Helmet } from 'react-helmet';

const Sales = () => {

    const [sales, setSales] = useState([]);
    const [saleDetail, setSaleDetail] = useState([]);
    const [filteredSales, setFilteredSales] = useState(sales);
    const [selectedSale, setSelectedSale] = useState(null);
    const [showDetail, setShowDetail] = useState(false);
    const [filters, setFilters] = useState({
        date: "",
        month: "",
        year: ""
    });

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [itemsPerPage] = useState(50);


    // Función para filtrar ventas
    const filterSales = () => {

        let filtered = sales;
        if (filters.date) {
            filtered = filtered.filter(sale => format(sale.sale_date, 'yyyy-MM-dd') === filters.date);
        }
        if (filters.month) {
            filtered = filtered.filter(sale => sale.sale_date.startsWith(filters.year + '-' + filters.month));
        }
        if (filters.year) {
            filtered = filtered.filter(sale => sale.sale_date.startsWith(filters.year));
        }
        setFilteredSales(filtered);
    };



    // Mostrar detalle de la venta
    const handleShowDetail = (sale) => {
        getSaleDetail(sale.id_sale);
        setShowDetail(true);
    };

    useEffect(() => {
        getSale(currentPage);
    }, [currentPage])


    const handlePageChange = (page) => {
        setCurrentPage(page);
    };


    const getSale = async (page) => {
        await dotoniwoofApi.get(`/sale.php?page=${page}&limit=${itemsPerPage}`)
            .then(res => {
                let responseApi = res.data;
                if (responseApi.code === 200) {
                    setSales(responseApi.message);
                    setFilteredSales(responseApi.message)
                    setTotalPages(responseApi.total_pages);
                }
            })
            .catch(err => {
                console.log(err);
            }).finally(
                () => {
                }
            )
    }

    const getSaleDetail = async (id_sale) => {
        await dotoniwoofApi.get(`/saleDetail.php/${id_sale}`)
            .then(res => {
                let responseApi = res.data;
                if (responseApi.code === 200) {
                    setSaleDetail(responseApi.message);
                    console.log(saleDetail);
                }
            })
            .catch(err => {
                console.log(err);
            }).finally(
                () => {
                }
            )
    }

    const closeModal = () => {
        setShowDetail(false);
        setSaleDetail([]);
    }

    return (
        <>
            <NavContainer></NavContainer>
            <OffCanvasNav></OffCanvasNav>
            <Helmet><title>
                Ventas
            </title></Helmet>
            <Container>
                <Row>
                    <Col>

                        <Titulo>Resumen de venta</Titulo>
                        {/* Filtros */}
                        <Form className="mb-3">
                            <Form.Group controlId="filterDate">
                                <Form.Label>Filtrar por Fecha</Form.Label>
                                <Form.Control
                                    type="date"
                                    onChange={(e) => setFilters({ ...filters, date: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="filterMonth">
                                <Form.Label>Filtrar por Mes</Form.Label>
                                <Form.Control
                                    type="number"
                                    min="1"
                                    max="12"
                                    placeholder="Mes (MM)"
                                    onChange={(e) => setFilters({ ...filters, month: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="filterYear">
                                <Form.Label>Filtrar por Año</Form.Label>
                                <Form.Control
                                    type="number"
                                    min="2020"
                                    placeholder="Año (YYYY)"
                                    onChange={(e) => setFilters({ ...filters, year: e.target.value })}
                                />
                            </Form.Group>
                            <br></br>
                            <Button variant="primary" onClick={filterSales}>
                                Buscar <IconSearch></IconSearch>
                            </Button>
                        </Form>

                        {/* Tabla de Ventas */}
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Fecha</th>
                                    <th>Total ($)</th>
                                    <th>Estado</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredSales.map((sale) => (
                                    <tr key={sale.id_sale}>
                                        <td>{sale.id_sale}</td>
                                        <td>{sale.sale_date}</td>
                                        <td>{sale.total_amount.toLocaleString("es-CO", { style: "currency", currency: "COP" })}</td>
                                        <td>{sale.status}</td>
                                        <td>
                                            <Button variant="info" style={{
                                                color: '#fff'
                                            }} onClick={() => handleShowDetail(sale)}>
                                                Ver Detalles <IconSearch></IconSearch>
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        {/* Paginación */}
                        <Pagination>
                            <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />

                            {/* Botones de número de página */}
                            {[...Array(totalPages).keys()].map((page) => (
                                <Pagination.Item
                                    key={page + 1}
                                    active={page + 1 === currentPage}
                                    onClick={() => handlePageChange(page + 1)}
                                >
                                    {page + 1}
                                </Pagination.Item>
                            ))}

                            <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                            <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
                        </Pagination>

                        {/* Modal para ver el detalle de la venta */}
                        <Modal show={showDetail} onHide={() => setShowDetail(false)}>
                            <Modal.Header closeButton>
                                <Modal.Title>Detalle de la Venta</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>

                                {/* Tabla de Ventas */}
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>ID Venta</th>
                                            <th>Nombre</th>
                                            <th>Precio</th>
                                            <th>Peso</th>
                                            <th>Color</th>
                                            <th>Talla</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {saleDetail.map((sale) => (
                                            <tr key={sale.id_sale_detail}>
                                                <td>{sale.id_sale_detail}</td>
                                                <td>{sale.description}</td>
                                                <td>{parseFloat(sale.unit_price).toLocaleString("es-CO", { style: "currency", currency: "COP" })}</td>
                                                <td>{sale.weight_name}</td>
                                                <td>{sale.color_name}</td>
                                                <td>{sale.size_name}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => closeModal()}>
                                    Cerrar
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </Col>
                </Row>
            </Container>


        </>);
}

export default Sales;